import Partner01 from '../../assets/partners/partner01.svg';
import Partner02 from '../../assets/partners/partner02.svg';
import Partner03 from '../../assets/partners/partner03.svg';
import Partner04 from '../../assets/partners/partner04.svg';
import Partner05 from '../../assets/partners/partner05.svg';
import Partner06 from '../../assets/partners/partner06.svg';

export const partnersData = [
  {
    preview: Partner01,
    id: '1',
  },
  {
    preview: Partner02,
    id: '2',
  },
  {
    preview: Partner03,
    id: '3',
  },
  {
    preview: Partner04,
    id: '4',
  },
  {
    preview: Partner05,
    id: '5',
  },
  {
    preview: Partner06,
    id: '6',
  },
];
